export default "__VITE_ASSET__3dc7bf76__"